import React from 'react';
import * as MD from '@material-ui/core';

import { Reducer } from 'redux';
import {
  EDetailEtudeID, ElectionType, EtudeType, ICircoFilters, IDashboardCircoData, IDataSimple, IDataTime, IDetailEtudeIdData, IElectionsActionTypes,
  IElectionsState, IElectionsStudyType, IPoliticalDataRow, IPoliticalGroupCircoData, IPoliticalGroupData, IRow, IRowData, IROWS, IStudyType, PRESIDENTIEL_ELECTION
} from './Types';
import { TypedStorage } from '../../Utils/TypedStorage';
import TalkDarkLogo from '../../Assets/talk-dark-logo.png';
import { sortObjectByKeys } from '../../Utils/String';

let initialEtudeType: EtudeType = TypedStorage.get('etude', EtudeType.PLURALISME)
const initialState: IElectionsState = {
  etude: initialEtudeType,
  detail_etude_ids: EDetailEtudeID,
  elections_start_date: null,
  elections_end_date: null,
  data_legis_circo: null,
  national_columns: [],
  national_data_hms: [],
  national_data_percent: [],
  regional_columns: [],
  regional_data_hms: [],
  regional_data_percent: [],
  regional_data: [],
  regional_virt_data: [],
  isElectionChecked: initialEtudeType === EtudeType.ELECTION ? true : false,
  study_types: null,
  get_circo_list_loading: false,
  elections_study_types: [],
  pluralisme_study_types: [],
  circonscriptions: [],
  circonscriptions_nat: [],
  allCirconscriptionsId: [],
  allCirconscriptionsStr: [],
  circonscriptionsVirt: [],
  allCirconscriptionsVirtId: [],
  allCirconscriptionsVirtStr: [],
  elections: null,
  circ_data: null,
  circ_virt_data: null,
  time_allocation_filters: null,
  dashboard_elections_filters: null,
  election_dashboard_loading: false,
  study_type_id: PRESIDENTIEL_ELECTION.FIRST_ROUND,
  dashboard_circonscriptions: null,
  tableType: ElectionType.NATIONAL,
  circonscription_dashboard_loading: false,
  circonscription_virt_dashboard_loading: false,
  xls_dashboard_election: null,
  xls_declaration_csa: null,
  xls_declaration_filters: null,
  circoFilters: {
    circo_ids: undefined,
    circo_virt_ids: undefined,
    is_nat: false
  },
  isDeclarationDetailLoading: false,
  decalarion_details: null,
  declarations_csa_filters: null,
  dasboardDetailsFilters: null,
  isLoadingDetail: false,
  isElectionsRegionale: false,
  isElectionPresedentielle: false,
  isElectionsLegislative: initialEtudeType === EtudeType.ELECTION ? true : false,
  dashboardElectionDetail: null,
  timeAllocationsLoading: false,
  timeAllocationResults: null,
  time_allocation_hms: [],
  time_allocation_percent: [],
  time_allocation_columns: [],
  elections_legis_nat_columns: [],
  elections_legis_cir_columns: [],
  elections_legis_loading: false,
  elections_legis_nat_results: null,
};

function editData(json: any, data: any) {
  if (json.milliseconds === 0) {
    data = "--"
  }
  return data
}
export function isElectionNational(id: number) {
  return id === 29 || id === 31 || id >= PRESIDENTIEL_ELECTION.FIRST_ROUND
}
export function getCurrentEtude(study_types: IElectionsStudyType[]) {
  return study_types[0];
  /*
  let selected_type = study_types[0];
  study_types.map(x => {
    if (x && new Date(x.start) <= new Date() && new Date(x.end) >= new Date()) {
      selected_type = x
      return selected_type
    }
    return selected_type
  })
  selected_type = study_types[study_types.length - 1]
  return selected_type
  */
}

const reducer: Reducer<IElectionsState> = (state = initialState, action) => {
  switch (action.type) {
    case IElectionsActionTypes.BUILD_NATIONAL_COLUMNS: {
      let columns: any[] = [
        {
          Header: <img
            key={'logo'}
            style={{
              marginTop: -40,
              marginLeft: -20
            }}
            height={40}
            src={TalkDarkLogo}
            alt={""} />,
          accessor: 'Libelle',
        },
        {
          Header: "Journaux",
          cid: 1,
          accessor: 'journaux',
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_journaux',
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_journaux'
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_journaux'
            },
            {
              Header: 'Percent',
              accessor: '%_temps_journaux'
            }
          ]
        },
        {
          Header: 'Magazines',
          cid: 3,
          accessor: 'magazines',
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_mag'
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_mag'
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_mag'
            },
            {
              Header: 'Percent',
              accessor: '%_temps_mag'
            }
          ]
        },
        {
          Header: 'Programmes',
          cid: 2,
          accessor: 'programmes',
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_autres'
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_autres'
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_autres'
            },
            {
              Header: 'Percent',
              accessor: '%_temps_autres'
            }
          ]
        },
        {
          Header: 'Total',
          accessor: 'total',
          columns: [
            {
              Header: 'Durée',
              accessor: 'duree_total'
            },
            {
              Header: 'Percent',
              accessor: '%_total'
            }
          ]
        }
      ]
      return {
        ...state,
        national_columns: columns,
      };
    }
    case IElectionsActionTypes.BUILD_REGIONAL_COLUMNS: {
      let columns: any[] = [
        {
          Header: '',
          accessor: 'Libelle',
          Cell: (cell: any) => {
            return (
              typeof (cell.value) === 'object' ?
                <MD.Grid container>
                  <MD.Grid item xs={6} style={{ borderRight: '1px solid', padding: '2px' }}>
                    {cell.cell.value.candidat}
                  </MD.Grid>
                  <MD.Grid item xs={6}>
                    {cell.cell.value.formation}
                  </MD.Grid>
                </MD.Grid>
                :
                cell.value
            )
          }
        },
        {
          Header: "Journaux",
          accessor: 'journaux',
          cid: 1,
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_journaux',
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_journaux',
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_journaux',
            },
            {
              Header: 'Percent',
              accessor: '%_temps_journaux',
            }
          ]
        },
        {
          Header: 'Magazines',
          accessor: 'magazines',
          cid: 3,
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_mag',
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_mag',
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_mag',
            },
            {
              Header: 'Percent',
              accessor: '%_temps_mag',
            }
          ]
        },
        {
          Header: 'Programmes',
          accessor: 'programmes',
          cid: 2,
          columns: [
            {
              Header: 'Candidats',
              accessor: 'candidats_autres',
            },
            {
              Header: 'Soutiens',
              accessor: 'soutiens_autres',
            },
            {
              Header: 'Durée',
              accessor: 'duree_temps_autres',
            },
            {
              Header: 'Percent',
              accessor: '%_temps_autres',
            }
          ]
        },
        {
          Header: "Cumuls",
          accessor: 'Cumuls',
          columns: [
            {
              Header: 'Durée',
              accessor: 'duree_total',
            },
            {
              Header: 'Percent',
              accessor: '%_total',
            },
          ]
        }
      ]
      return {
        ...state,
        regional_columns: columns
      };
    }
    case IElectionsActionTypes.BUILD_ELECTION_PRES_COLUMNS: {
      let detail_etude_parole_id = state.detail_etude_ids.PAROLE;
      let detail_etude_antenne_id = state.detail_etude_ids.ANTENNE;
      let columns: any[] = [];
      columns = [
        {
          Header: <img
            key={'logo'}
            style={{
              marginTop: -40,
              marginLeft: -20
            }}
            height={40}
            src={TalkDarkLogo}
            alt={""} />,
          accessor: 'Libelle',
        },
        {
          Header: "Temps de Parole",
          accessor: detail_etude_parole_id.toString(),//'231563',
          columns: [
            {
              Header: 'Candidats',
              accessor: `candidats_${detail_etude_parole_id}` //'candidats_231563',
            },
            {
              Header: 'Soutiens',
              accessor: `soutiens_${detail_etude_parole_id}`//'soutiens_231563'
            },
            {
              Header: 'Durée',
              accessor: `duree_${detail_etude_parole_id}` //'duree_231563'
            },
            {
              Header: 'Percent',
              accessor: `%_${detail_etude_parole_id}` //'%_231563'
            }
          ]
        },
        {
          Header: "Temps d'Antenne",
          accessor: detail_etude_antenne_id.toString(),// '231562',
          columns: [
            {
              Header: 'Durée',
              accessor: `duree_${detail_etude_antenne_id}` //'duree_231562'
            },
            {
              Header: 'Percent',
              accessor: `%_${detail_etude_antenne_id}` //'%_231562'
            },
          ]
        },
      ]
      if (action.payload[1]["show_total"]) {
        columns.push(
          {
            Header: 'Total',
            accessor: 'total',
            columns: [
              {
                Header: 'Durée',
                accessor: 'duree_total'
              },
              {
                Header: 'Percent',
                accessor: '%_total'
              }
            ]
          }
        )
      }
      return {
        ...state,
        time_allocation_columns: columns,
      };
    }
    case IElectionsActionTypes.BUILD_ELECTION_LEGIS_CIR_COLUMNS: {
      let columns: any[] = [
        {
          Header: '',
          accessor: 'Libelle',
          Cell: (cell: any) => {
            if (typeof (cell.value) === 'object' && !cell.cell.value.formation) {
              return cell.cell.value.candidat;
            }
            return (
              typeof (cell.value) === 'object' ?
                <MD.Grid container>
                  <MD.Grid item xs={6} style={{ borderRight: '1px solid', padding: '2px' }}>
                    {cell.cell.value.candidat}
                  </MD.Grid>
                  <MD.Grid item xs={6}>
                    {cell.cell.value.formation}
                  </MD.Grid>
                </MD.Grid>
                :
                cell.value
            )
          }
        },
        {
          Header: "Emissions d'information (Journaux + Magazines)",
          accessor: "journaux_magazines",
          columns: [
            {
              Header: "Journaux d'information",
              accessor: "journaux",
              cid: 1,
              columns: [
                {
                  Header: "Candidats",
                  accessor: "candidats_journaux"
                },
                {
                  Header: "Soutiens",
                  accessor: "soutien_journaux"
                },
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_journaux"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_journaux"
                },
              ]
            },
            {
              Header: "Magazines d'information",
              cid: 3,
              accessor: "magazines",
              columns: [
                {
                  Header: "Candidats",
                  accessor: "candidats_magazines"
                },
                {
                  Header: "Soutiens",
                  accessor: "soutien_magazines"
                },
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_magazines"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_magazines"
                },
              ]
            },
            {
              Header: "TOTAL Emissions d'information",
              accessor: "total_emission",
              columns: [
                {
                  Header: "Durée Totale Temps de Parole",
                  accessor: "duree_emission"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_emission"
                },
              ]
            },
          ]
        },
        {
          Header: "",
          accessor: "aut_emiss_none",
          columns: [
            {
              Header: "Autres émissions",
              cid: "restyle",
              accessor: "autres_emissions",
              columns: [
                {
                  Header: "Candidats",
                  accessor: "candidats_autres"
                },
                {
                  Header: "Soutiens",
                  accessor: "soutien_autres"
                },
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_autres_emissions"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_autres_emissions"
                },
              ]
            }
          ]
        },
        {
          Header: "",
          accessor: "total_none",
          columns: [
            {
              Header: "TOTAL Journaux + Magazines d'information + Autres Emissions",
              cid: "none",
              accessor: "total",
              columns: [
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_total"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_total"
                },
              ]
            }
          ]
        }
      ]

      return {
        ...state,
        elections_legis_cir_columns: columns,
      };
    }
    case IElectionsActionTypes.BUILD_ELECTION_LEGIS_CIR_COLUMNS_V0: {
      let detail_etude_parole_id = state.detail_etude_ids.PAROLE;
      let columns: any[] = [
        {
          Header: '',
          accessor: 'Libelle',
          Cell: (cell: any) => {
            return (
              typeof (cell.value) === 'object' ?
                <MD.Grid container>
                  <MD.Grid item xs={6} style={{ borderRight: '1px solid', padding: '2px' }}>
                    {cell.cell.value.candidat}
                  </MD.Grid>
                  <MD.Grid item xs={6}>
                    {cell.cell.value.formation}
                  </MD.Grid>
                </MD.Grid>
                :
                cell.value
            )
          }
        },
        {
          Header: "Temps de Parole",
          accessor: detail_etude_parole_id.toString(),//'231563',
          columns: [
            {
              Header: 'Candidats',
              accessor: `candidats_${detail_etude_parole_id}`, //'candidats_231563',
            },
            {
              Header: 'Soutiens',
              accessor: `soutiens_${detail_etude_parole_id}`,//'soutiens_231563'
            },
            {
              Header: 'Durée',
              accessor: `duree_${detail_etude_parole_id}` //'duree_231563'
            },
            {
              Header: 'Percent',
              accessor: `%_${detail_etude_parole_id}` //'%_231563'
            }
          ]
        }
      ]

      return {
        ...state,
        elections_legis_cir_columns: columns,
      };
    }
    case IElectionsActionTypes.BUILD_ELECTION_LEGIS_NAT_COLUMNS: {
      let columns: any[] = [
        {
          Header: <img
            key={'logo'}
            style={{
              marginTop: -40,
              marginLeft: -20
            }}
            height={40}
            src={TalkDarkLogo}
            alt={""} />,
          accessor: 'Libelle',
        },
        {
          Header: "Emissions d'information (Journaux + Magazines)",
          accessor: "journaux_magazines",
          columns: [
            {
              Header: "Journaux d'information",
              accessor: "journaux",
              cid: 1,
              columns: [
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_journaux"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_journaux"
                },
              ]
            },
            {
              Header: "Magazines d'information",
              cid: 3,
              accessor: "magazines",
              columns: [
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_magazines"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_magazines"
                },
              ]
            },
            {
              Header: "TOTAL Emissions d'information",
              accessor: "total_emission",
              columns: [
                {
                  Header: "Durée Totale Temps de Parole",
                  accessor: "duree_emission"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_emission"
                },
              ]
            },
          ]
        },
        {
          Header: "",
          accessor: "aut_emiss_none",
          columns: [
            {
              Header: "Autres émissions",
              cid: "restyle",
              accessor: "autres_emissions",
              columns: [
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_autres_emissions"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_autres_emissions"
                },
              ]
            }
          ]
        },
        {
          Header: "",
          accessor: "total_none",
          columns: [
            {
              Header: "TOTAL Journaux + Magazines d'information + Autres Emissions",
              cid: "none",
              accessor: "total",
              columns: [
                {
                  Header: "Durée Temps de Parole",
                  accessor: "duree_total"
                },
                {
                  Header: "% Temps de Parole",
                  accessor: "%_total"
                },
              ]
            }
          ]
        }
      ]

      return {
        ...state,
        elections_legis_nat_columns: columns,
      };
    }
    case IElectionsActionTypes.BUILD_ELECTION_LEGIS_NAT_COLUMNS_V0: {
      let detail_etude_parole_id = state.detail_etude_ids.PAROLE;
      let columns: any[] = [];
      columns = [
        {
          Header: <img
            key={'logo'}
            style={{
              marginTop: -40,
              marginLeft: -20
            }}
            height={40}
            src={TalkDarkLogo}
            alt={""} />,
          accessor: 'Libelle',
        },
        {
          Header: "Temps de Parole",
          accessor: detail_etude_parole_id.toString(),//'231563',
          columns: [
            /* {
              Header: 'Candidats',
              accessor: `candidats_${detail_etude_parole_id}`, //'candidats_231563',
            },
            {
              Header: 'Soutiens',
              accessor: `soutiens_${detail_etude_parole_id}`,//'soutiens_231563'
            }, */
            {
              Header: 'Durée',
              accessor: `duree_${detail_etude_parole_id}` //'duree_231563'
            },
            {
              Header: 'Percent',
              accessor: `%_${detail_etude_parole_id}` //'%_231563'
            }
          ]
        }
      ]
      if (false) {
        columns.push(
          {
            Header: 'Total',
            accessor: 'total',
            columns: [
              {
                Header: 'Durée',
                accessor: 'duree_total'
              },
              {
                Header: 'Percent',
                accessor: '%_total'
              }
            ]
          }
        )
      }

      return {
        ...state,
        elections_legis_nat_columns: columns,
      };
    }
    case IElectionsActionTypes.SET_STUDY_TYPE: {
      if (action.payload) {
        return {
          ...state,
          elections_start_date: new Date(action.payload.start),
          elections_end_date: new Date(action.payload.end),
          isElectionPresedentielle: action.payload.id >= PRESIDENTIEL_ELECTION.FIRST_ROUND && action.payload.id <= PRESIDENTIEL_ELECTION.LAST_ROUND,//false,
          isElectionsLegislative: action.payload.id > PRESIDENTIEL_ELECTION.LAST_ROUND,//state.elections_study_types.some(x => x.id === action.payload.id),//action.payload.id === 33,
          study_type_id: action.payload.id,
          timeAllocationResults: null,
          timeAllocationsLoading: false,
          data_legis_circo: null
        }
      }
      return state
    }
    case IElectionsActionTypes.SET_ELECTION_PAGE: {
      TypedStorage.set('etude', action.payload ? EtudeType.ELECTION : EtudeType.PLURALISME);
      if (!action.payload) {
        return {
          ...state,
          isElectionChecked: action.payload,
          elections: null,
          national_data_hms: [],
          national_data_percent: [],
          regional_data_hms: [],
          regional_data_percent: [],
          time_allocation_hms: [],
          time_allocation_percent: [],
          etude: EtudeType.PLURALISME,
          isElectionPresedentielle: false,
          isElectionsLegislative: false,
          dashboard_elections_filters: null,
          time_allocation_filters: null,
          study_type_id: 24
        }
      } else return {
        ...state,
        isElectionChecked: action.payload,
        isElectionPresedentielle: false,
        isElectionsLegislative: true,
        etude: EtudeType.ELECTION,
        dashboard_elections_filters: null,
        study_type_id: state.elections_study_types !== null ? getCurrentEtude(state.elections_study_types).id : PRESIDENTIEL_ELECTION.FIRST_ROUND,
        elections_start_date: state.elections_study_types && state.elections_study_types.length > 0 ? new Date(getCurrentEtude(state.elections_study_types).start) : new Date(2021, 4, 10, 0, 0, 0, 0)
      }
    }
    case IElectionsActionTypes.SET_ELECTION_TABLE: {
      return {
        ...state,
        tableType: action.payload
      }
    }
    case IElectionsActionTypes.GET_STUDY_TYPES: {
      return {
        ...state,
      }
    }
    case IElectionsActionTypes.GET_STUDY_TYPES_SUCCESS: {
      let results: IStudyType = action.payload
      let elections = [...results.elections]
      //elections = elections.filter(x => new Date(x.end) >= new Date())
      elections = elections.filter(x => x.id >= PRESIDENTIEL_ELECTION.FIRST_ROUND);
      if (elections && elections.length > 0) {
        return {
          ...state,
          study_types: results,
          study_type_id: getCurrentEtude(elections).id,
          elections_study_types: elections,
          pluralisme_study_types: results.pluralisme,
          elections_end_date: new Date(getCurrentEtude(elections).end),
          elections_start_date: new Date(getCurrentEtude(elections).start)
        }
      } else {
        return {
          ...state,
          study_types: results,
          elections_study_types: elections,
          pluralisme_study_types: results.pluralisme
        }
      }
    }
    case IElectionsActionTypes.GET_DETAIL_ETUDE_IDS: {
      return {
        ...state
      }
    }
    case IElectionsActionTypes.GET_DETAIL_ETUDE_IDS_SUCCESS: {
      if (action.payload) {
        let filtered_item_antenne = action.payload.filter(x => x.name && x.name.toLowerCase().indexOf('antenne') > -1)[0];
        let filtered_item_parole = action.payload.filter(x => x.name && x.name.toLowerCase().indexOf('parole') > -1)[0];
        if (filtered_item_parole !== undefined && filtered_item_antenne !== undefined) {
          let id_parole = filtered_item_parole.id;
          let id_antenne = filtered_item_antenne.id;
          return {
            ...state,
            detail_etude_ids: {
              PAROLE: id_parole,
              ANTENNE: id_antenne
            }
          }
        }
        return state

      }
      return state
    }
    case IElectionsActionTypes.GET_CIRCO_LIST: {
      return {
        ...state,
        get_circo_list_loading: true,
        circonscriptions: [],
        circonscriptionsVirt: [],
        study_type_id: action.payload[0],
        dashboard_elections_filters: state.dashboard_elections_filters === null ? null : {
          ...state.dashboard_elections_filters,
          study_type_id: action.payload[0]
        },
        //tableType: isElectionNational(action.payload[0]) ? ElectionType.NATIONAL : ElectionType.CIRCONSCRIPTION,
        regional_data: [],
        regional_virt_data: [],
        elections_legis_nat_results: null,
        time_allocation_hms: [],
      }
    }
    case IElectionsActionTypes.GET_CIRCO_LIST_SUCCESS: {
      let ids: number[] = action.payload.map(x => x.id)
      let str: string[] = action.payload.map(x => x.name)

      return {
        ...state,
        circonscriptions: action.payload,
        allCirconscriptionsStr: str,
        allCirconscriptionsId: ids,
        get_circo_list_loading: false
      }
    }
    case IElectionsActionTypes.GET_CIRCO_VIRT_LIST: {
      return {
        ...state,
        study_type_id: action.payload[0],
        dashboard_elections_filters: state.dashboard_elections_filters === null ? null : {
          ...state.dashboard_elections_filters,
          study_type_id: action.payload[0]
        },
        //tableType: isElectionNational(action.payload[0]) ? ElectionType.NATIONAL : ElectionType.CIRCONSCRIPTION,
        regional_data: [],
        regional_virt_data: [],
        circonscriptions: [],
        circonscriptionsVirt: [],
      }
    }
    case IElectionsActionTypes.GET_CIRCO_VIRT_LIST_SUCCESS: {
      let ids: number[] = action.payload.map(x => x.id)
      let str: string[] = action.payload.map(x => x.name)
      return {
        ...state,
        circonscriptionsVirt: action.payload,
        allCirconscriptionsVirtStr: str,
        allCirconscriptionsVirtId: ids
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE: {
      return {
        ...state,
        dashboard_elections_filters: action.payload,
        study_type_id: action.payload.study_type_id,
        election_dashboard_loading: true,
        dashboardElectionDetail: null,
        timeAllocationResults: null
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS: {
      let res: any = action.payload[0];
      let data_global = {};
      Object.keys(res).map(by_detail_etude_id => {
        let data_hms: any = [];
        let data_percent: any = [];
        let etude = res[by_detail_etude_id];
        let detail_etude_id = etude.detail_etude_id;
        let detail_etude_name = etude.detail_etude_name;
        let etude_datas = etude.datas;
        Object.keys(etude_datas).map(by_political_group_id => {

          let json_hms: any = { "Libelle": {} };
          let json_percent: any = { "Libelle": {} };
          json_hms["detail_etude_id"] = detail_etude_id;
          let political_group = etude_datas[by_political_group_id];
          let political_group_id = political_group.political_group_id;
          let political_group_name = political_group.political_group_name;

          json_hms["Libelle"]["candidat"] = political_group_name
          json_hms["Libelle"]["formation"] = political_group.person_firstname;
          json_hms["political_group_id"] = political_group_id;
          let political_group_datas: IPoliticalDataRow = political_group.datas;
          let journaux_candidats = political_group_datas.JOURNAUX.CANDIDAT;
          json_hms["candidats_journaux"] = journaux_candidats.milliseconds === 0 ? "--" : journaux_candidats.hms;
          let journaux_soutien = political_group_datas.JOURNAUX.SOUTIEN;
          json_hms["soutien_journaux"] = journaux_soutien.milliseconds === 0 ? "--" : journaux_soutien.hms;
          let journaux_datas = political_group_datas.JOURNAUX.TOTAL;
          json_hms["duree_journaux"] = journaux_datas.milliseconds === 0 ? "--" : journaux_datas.hms;
          json_hms["%_journaux"] = journaux_datas.milliseconds === 0 ? "--" : journaux_datas.percent;
          let magazines_candidats = political_group_datas.MAGAZINES.CANDIDAT;
          json_hms["candidats_magazines"] = magazines_candidats.milliseconds === 0 ? "--" : magazines_candidats.hms;
          let magazines_soutien = political_group_datas.MAGAZINES.SOUTIEN;
          json_hms["soutien_magazines"] = magazines_soutien.milliseconds === 0 ? "--" : magazines_soutien.hms;
          let magazines_datas = political_group_datas.MAGAZINES.TOTAL;
          json_hms["duree_magazines"] = magazines_datas.milliseconds === 0 ? "--" : magazines_datas.hms;
          json_hms["%_magazines"] = magazines_datas.milliseconds === 0 ? "--" : magazines_datas.percent;
          let emissions_datas = political_group_datas.EMISSIONS.TOTAL;
          json_hms["duree_emission"] = emissions_datas.milliseconds === 0 ? "--" : emissions_datas.hms;
          json_hms["%_emission"] = emissions_datas.milliseconds === 0 ? "--" : emissions_datas.percent;
          let autres_candidats = political_group_datas.AUTRES.CANDIDAT;
          json_hms["candidats_autres"] = autres_candidats.milliseconds === 0 ? "--" : autres_candidats.hms;
          let autres_soutien = political_group_datas.AUTRES.SOUTIEN;
          json_hms["soutien_autres"] = autres_soutien.milliseconds === 0 ? "--" : autres_soutien.hms;
          let autres_datas = political_group_datas.AUTRES.TOTAL;
          json_hms["duree_autres_emissions"] = autres_datas.milliseconds === 0 ? "--" : autres_datas.hms;
          json_hms["%_autres_emissions"] = autres_datas.milliseconds === 0 ? "--" : autres_datas.percent;
          let total_datas = political_group_datas.TOTAL.TOTAL;
          json_hms["duree_total"] = total_datas.milliseconds === 0 ? "--" : total_datas.hms;
          json_hms["%_total"] = total_datas.milliseconds === 0 ? "--" : total_datas.percent;
          json_percent = { ...json_hms };
          data_hms.push(json_hms);
          data_percent.push(json_percent);
          return [data_hms, data_percent]
        })
        let etude_totaux: IPoliticalDataRow = etude.totaux;
        let json_hms_total = {};
        let json_percent_total = {};
        json_hms_total['Libelle'] = 'Totaux';
        json_hms_total["detail_etude_id"] = detail_etude_id;
        let etude_totaux_journaux: IDataSimple = etude_totaux.JOURNAUX.TOTAL;
        json_hms_total["duree_journaux"] = etude_totaux_journaux.milliseconds === 0 ? "--" : etude_totaux_journaux.hms;
        json_hms_total["%_journaux"] = etude_totaux_journaux.milliseconds === 0 ? "--" : etude_totaux_journaux.percent;
        let etude_totaux_magazines: IDataSimple = etude_totaux.MAGAZINES.TOTAL;
        json_hms_total["duree_magazines"] = etude_totaux_magazines.milliseconds === 0 ? "--" : etude_totaux_magazines.hms;
        json_hms_total["%_magazines"] = etude_totaux_magazines.milliseconds === 0 ? "--" : etude_totaux_magazines.percent;
        let etude_totaux_emissions: IDataSimple = etude_totaux.EMISSIONS.TOTAL;
        json_hms_total["duree_emission"] = etude_totaux_emissions.milliseconds === 0 ? "--" : etude_totaux_emissions.hms;
        json_hms_total["%_emission"] = etude_totaux_emissions.milliseconds === 0 ? "--" : etude_totaux_emissions.percent;
        let etude_totaux_autres: IDataSimple = etude_totaux.AUTRES.TOTAL;
        json_hms_total["duree_autres_emissions"] = etude_totaux_autres.milliseconds === 0 ? "--" : etude_totaux_autres.hms;
        json_hms_total["%_autres_emissions"] = etude_totaux_autres.milliseconds === 0 ? "--" : etude_totaux_autres.percent;
        let etude_totaux_total: IDataSimple = etude_totaux.TOTAL.TOTAL;
        json_hms_total["duree_total"] = etude_totaux_total.milliseconds === 0 ? "--" : etude_totaux_total.hms;
        json_hms_total["%_total"] = etude_totaux_total.milliseconds === 0 ? "--" : etude_totaux_total.percent;
        json_percent_total = { ...json_percent_total };
        data_hms.push(json_hms_total);
        data_percent.push(json_percent_total);
        data_global[detail_etude_name] = { "id": detail_etude_id, "data_hms": data_hms, "data_percent": data_percent }
        return data_global
      })
      data_global = sortObjectByKeys(data_global);



      return {
        ...state,
        data_legis_circo: data_global,
        timeAllocationsLoading: false,
        timeAllocationResults: action.payload,
        tableType: ElectionType.CIRCONSCRIPTION,
        election_dashboard_loading: false
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS_V0: {
      let res: any = action.payload[0];
      let detail_etude_parole_id = state.detail_etude_ids.PAROLE;
      let data_global = {};
      Object.keys(res).map(detail_etude_id => {
        // fill legislativ rows datas
        let data_hms: any = []
        let data_percent: any = []
        let rows_by_detail_etude_id = res[detail_etude_id];
        let detail_etude_name = rows_by_detail_etude_id.detail_etude_name;
        let rows_by_political_group_id = rows_by_detail_etude_id.datas;
        Object.keys(rows_by_political_group_id).map((pgid: any, index: number) => {
          let row_by_political_group_data: IPoliticalGroupCircoData = rows_by_political_group_id[pgid];
          let political_group_data: IDataTime = row_by_political_group_data.datas;

          let existed_json_hms = data_hms.filter(x => x.political_group_id === parseInt(pgid))[0];
          let existed_json_percent = data_percent.filter(x => x.political_group_id === parseInt(pgid))[0];
          let json_hms: any = existed_json_hms || { "Libelle": {} };
          let json_percent: any = existed_json_percent || { "Libelle": {} };

          json_hms["political_group_id"] = row_by_political_group_data.political_group_id;
          json_hms["political_regime_id"] = row_by_political_group_data.political_regime_id;
          json_hms["detail_etude_id"] = parseInt(detail_etude_id);
          json_hms["Libelle"]["candidat"] = row_by_political_group_data.political_group_name
          json_hms["Libelle"]["formation"] = row_by_political_group_data.person_firstname;
          json_percent = { ...json_hms }
          if (political_group_data.CANDIDAT) {
            json_hms[`candidats_${detail_etude_parole_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.hms;
            json_percent[`candidats_${detail_etude_parole_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.percent;
          } else {
            json_hms[`candidats_${detail_etude_parole_id}`] = "--";
            json_percent[`candidats_${detail_etude_parole_id}`] = "--";
          }

          if (political_group_data.SOUTIEN) {
            json_hms[`soutiens_${detail_etude_parole_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.hms;
            json_percent[`soutiens_${detail_etude_parole_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.percent;
          } else {
            json_hms[`soutiens_${detail_etude_parole_id}`] = "--";
            json_percent[`soutiens_${detail_etude_parole_id}`] = "--";
          }

          json_hms[`duree_${detail_etude_parole_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.hms
          json_hms[`%_${detail_etude_parole_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.percent
          json_percent[`duree_${detail_etude_parole_id}`] = json_hms[`duree_${detail_etude_parole_id}`];
          json_percent[`%_${detail_etude_parole_id}`] = json_hms[`%_${detail_etude_parole_id}`];

          if (!existed_json_hms) {
            data_hms.push(json_hms)
            data_percent.push(json_percent)
          }
          data_global[detail_etude_name] = { "id": detail_etude_id, "data_hms": data_hms, "data_percent": data_percent }
          return data_global
        })
        let totaux: IDataTime = rows_by_detail_etude_id.totaux;
        let json_total_hms: any = { "Libelle": "Total" };
        let json_total_percent: any = { "Libelle": "Total" };

        json_total_hms["detail_etude_id"] = parseInt(detail_etude_id);
        json_total_percent = { ...json_total_hms }
        if (totaux.CANDIDAT) {
          json_total_hms[`candidats_${detail_etude_parole_id}`] = totaux.CANDIDAT.milliseconds === 0 ? "--" : totaux.CANDIDAT.hms
          json_total_percent[`candidats_${detail_etude_parole_id}`] = totaux.CANDIDAT.milliseconds === 0 ? "--" : totaux.CANDIDAT.percent

        }
        if (totaux.SOUTIEN) {
          json_total_hms[`soutiens_${detail_etude_parole_id}`] = totaux.SOUTIEN.milliseconds === 0 ? "--" : totaux.SOUTIEN.hms
          json_total_percent[`soutiens_${detail_etude_parole_id}`] = totaux.SOUTIEN.milliseconds === 0 ? "--" : totaux.SOUTIEN.percent

        }
        json_total_hms[`duree_${detail_etude_parole_id}`] = totaux.TOTAL.milliseconds === 0 ? "--" : totaux.TOTAL.hms
        json_total_percent[`duree_${detail_etude_parole_id}`] = json_total_hms[`duree_${detail_etude_parole_id}`];
        json_total_hms[`%_${detail_etude_parole_id}`] = totaux.TOTAL.milliseconds === 0 ? "--" : totaux.TOTAL.percent
        json_total_percent[`%_${detail_etude_parole_id}`] = json_total_hms[`%_${detail_etude_parole_id}`]

        data_hms.push(json_total_hms)
        data_percent.push(json_total_percent)




        data_global[detail_etude_name] = { "id": detail_etude_id, "data_hms": data_hms, "data_percent": data_percent }
        return data_global
      })

      return {
        ...state,
        data_legis_circo: data_global,
        timeAllocationsLoading: false,
        timeAllocationResults: action.payload,
        tableType: ElectionType.CIRCONSCRIPTION,
        election_dashboard_loading: false
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS: {
      let data_hms: any = [];
      let data_percent: any = [];
      let res: any = action.payload[0];
      Object.keys(res).map(by_detail_etude_id => {
        let etude = res[by_detail_etude_id];
        let detail_etude_id = etude.detail_etude_id;
        let etude_datas = etude.datas;
        Object.keys(etude_datas).map(by_political_group_id => {

          let json_hms: any = {};
          let json_percent: any = {};
          json_hms["detail_etude_id"] = detail_etude_id;
          let political_group = etude_datas[by_political_group_id];
          let political_group_id = political_group.political_group_id;
          let political_group_name = political_group.political_group_name;
          json_hms["Libelle"] = political_group_name;
          json_hms["political_group_id"] = political_group_id;
          let political_group_datas: IPoliticalDataRow = political_group.datas;
          let journaux_datas = political_group_datas.JOURNAUX.TOTAL;
          json_hms["duree_journaux"] = journaux_datas.milliseconds === 0 ? "--" : journaux_datas.hms;
          json_hms["%_journaux"] = journaux_datas.milliseconds === 0 ? "--" : journaux_datas.percent;
          let magazines_datas = political_group_datas.MAGAZINES.TOTAL;
          json_hms["duree_magazines"] = magazines_datas.milliseconds === 0 ? "--" : magazines_datas.hms;
          json_hms["%_magazines"] = magazines_datas.milliseconds === 0 ? "--" : magazines_datas.percent;
          let emissions_datas = political_group_datas.EMISSIONS.TOTAL;
          json_hms["duree_emission"] = emissions_datas.milliseconds === 0 ? "--" : emissions_datas.hms;
          json_hms["%_emission"] = emissions_datas.milliseconds === 0 ? "--" : emissions_datas.percent;
          let autres_datas = political_group_datas.AUTRES.TOTAL;
          json_hms["duree_autres_emissions"] = autres_datas.milliseconds === 0 ? "--" : autres_datas.hms;
          json_hms["%_autres_emissions"] = autres_datas.milliseconds === 0 ? "--" : autres_datas.percent;
          let total_datas = political_group_datas.TOTAL.TOTAL;
          json_hms["duree_total"] = total_datas.milliseconds === 0 ? "--" : total_datas.hms;
          json_hms["%_total"] = total_datas.milliseconds === 0 ? "--" : total_datas.percent;
          json_percent = { ...json_hms };
          data_hms.push(json_hms);
          data_percent.push(json_percent);
          return [data_hms, data_percent]
        })
        let etude_totaux: IPoliticalDataRow = etude.totaux;
        let json_hms_total = {};
        let json_percent_total = {};
        json_hms_total['Libelle'] = 'Totaux';
        json_hms_total["detail_etude_id"] = detail_etude_id;
        let etude_totaux_journaux: IDataSimple = etude_totaux.JOURNAUX.TOTAL;
        json_hms_total["duree_journaux"] = etude_totaux_journaux.milliseconds === 0 ? "--" : etude_totaux_journaux.hms;
        json_hms_total["%_journaux"] = etude_totaux_journaux.milliseconds === 0 ? "--" : etude_totaux_journaux.percent;
        let etude_totaux_magazines: IDataSimple = etude_totaux.MAGAZINES.TOTAL;
        json_hms_total["duree_magazines"] = etude_totaux_magazines.milliseconds === 0 ? "--" : etude_totaux_magazines.hms;
        json_hms_total["%_magazines"] = etude_totaux_magazines.milliseconds === 0 ? "--" : etude_totaux_magazines.percent;
        let etude_totaux_emissions: IDataSimple = etude_totaux.EMISSIONS.TOTAL;
        json_hms_total["duree_emission"] = etude_totaux_emissions.milliseconds === 0 ? "--" : etude_totaux_emissions.hms;
        json_hms_total["%_emission"] = etude_totaux_emissions.milliseconds === 0 ? "--" : etude_totaux_emissions.percent;
        let etude_totaux_autres: IDataSimple = etude_totaux.AUTRES.TOTAL;
        json_hms_total["duree_autres_emissions"] = etude_totaux_autres.milliseconds === 0 ? "--" : etude_totaux_autres.hms;
        json_hms_total["%_autres_emissions"] = etude_totaux_autres.milliseconds === 0 ? "--" : etude_totaux_autres.percent;
        let etude_totaux_total: IDataSimple = etude_totaux.TOTAL.TOTAL;
        json_hms_total["duree_total"] = etude_totaux_total.milliseconds === 0 ? "--" : etude_totaux_total.hms;
        json_hms_total["%_total"] = etude_totaux_total.milliseconds === 0 ? "--" : etude_totaux_total.percent;
        json_percent_total = { ...json_percent_total };
        data_hms.push(json_hms_total);
        data_percent.push(json_percent_total);
        return [data_hms, data_percent]
      })




      return {
        ...state,
        time_allocation_hms: data_hms,
        time_allocation_percent: data_percent,
        timeAllocationsLoading: false,
        timeAllocationResults: action.payload[0],
        tableType: ElectionType.NATIONAL,
        election_dashboard_loading: false
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS_V0: {
      let data_hms: any = []
      let data_percent: any = []
      let json_hms: any = {};
      let json_percent: any = {};
      let res: any = action.payload[0];
      let detail_etude_parole_id = state.detail_etude_ids.PAROLE;
      Object.keys(res).map(detail_etude_id => {
        // fill legislativ rows datas
        let rows_by_detail_etude_id = res[detail_etude_id];
        let rows_by_political_group_id = rows_by_detail_etude_id.datas;
        Object.keys(rows_by_political_group_id).map(pgid => {
          let row_by_political_group_data: IPoliticalGroupData = rows_by_political_group_id[pgid];
          let political_group_data: IDataTime = row_by_political_group_data.datas;

          json_hms["political_group_id"] = row_by_political_group_data.political_group_id;
          json_hms["political_regime_id"] = row_by_political_group_data.political_regime_id;
          json_hms["Libelle"] = row_by_political_group_data.political_group_name;
          json_percent = { ...json_hms }
          if (political_group_data.CANDIDAT) {
            json_hms[`candidats_${detail_etude_parole_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.hms;
            json_percent[`candidats_${detail_etude_parole_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.percent;
          } else {
            json_hms[`candidats_${detail_etude_parole_id}`] = "--";
            json_percent[`candidats_${detail_etude_parole_id}`] = "--";
          }

          if (political_group_data.SOUTIEN) {
            json_hms[`soutiens_${detail_etude_parole_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.hms;
            json_percent[`soutiens_${detail_etude_parole_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.percent;
          } else {
            json_hms[`soutiens_${detail_etude_parole_id}`] = "--";
            json_percent[`soutiens_${detail_etude_parole_id}`] = "--";
          }

          json_hms[`duree_${detail_etude_parole_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.hms
          json_hms[`%_${detail_etude_parole_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.percent
          json_percent[`duree_${detail_etude_parole_id}`] = json_hms[`duree_${detail_etude_parole_id}`];
          json_percent[`%_${detail_etude_parole_id}`] = json_hms[`%_${detail_etude_parole_id}`];

          data_hms.push(json_hms)
          data_percent.push(json_percent)
          return [data_hms, data_percent]
        })

        let totaux: IDataTime = rows_by_detail_etude_id.totaux;
        let json_total_hms: any = { "Libelle": "Total" };
        let json_total_percent: any = { "Libelle": "Total" };
        if (totaux.CANDIDAT) {
          json_total_hms[`candidats_${detail_etude_parole_id}`] = totaux.CANDIDAT.milliseconds === 0 ? "--" : totaux.CANDIDAT.hms
          json_total_percent[`candidats_${detail_etude_parole_id}`] = totaux.CANDIDAT.milliseconds === 0 ? "--" : totaux.CANDIDAT.percent

        }
        if (totaux.SOUTIEN) {
          json_total_hms[`soutiens_${detail_etude_parole_id}`] = totaux.SOUTIEN.milliseconds === 0 ? "--" : totaux.SOUTIEN.hms
          json_total_percent[`soutiens_${detail_etude_parole_id}`] = totaux.SOUTIEN.milliseconds === 0 ? "--" : totaux.SOUTIEN.percent

        }
        json_total_hms[`duree_${detail_etude_parole_id}`] = totaux.TOTAL.milliseconds === 0 ? "--" : totaux.TOTAL.hms
        json_total_percent[`duree_${detail_etude_parole_id}`] = json_total_hms[`duree_${detail_etude_parole_id}`];
        json_total_hms[`%_${detail_etude_parole_id}`] = totaux.TOTAL.milliseconds === 0 ? "--" : totaux.TOTAL.percent
        json_total_percent[`%_${detail_etude_parole_id}`] = json_total_hms[`%_${detail_etude_parole_id}`]

        data_hms.push(json_total_hms)
        data_percent.push(json_total_percent)




        return [data_hms, data_percent]
      })
      return {
        ...state,
        time_allocation_hms: data_hms,
        time_allocation_percent: data_percent,
        timeAllocationsLoading: false,
        timeAllocationResults: action.payload[0],
        tableType: ElectionType.NATIONAL,
        election_dashboard_loading: false
      }
    }
    case IElectionsActionTypes.GET_DASHBOARD_ELECTION: {
      return {
        ...state,
        dashboard_elections_filters: action.payload,
        study_type_id: action.payload.study_type_id,
        election_dashboard_loading: true,
        dashboardElectionDetail: null
      }
    }
    case IElectionsActionTypes.GET_DASHBOARD_ELECTION_SUCCESS: {
      let data_hms: any = []
      let data_percent: any = []
      let res: any = action.payload
      Object.keys(res).map(key => {
        if (key.toUpperCase() === 'ROWS') {
          let rows: any = res[key]
          Object.keys(rows).map(row_id => {
            let row: IRowData = rows[row_id]
            let json_hms: any = {}
            let json_percent: any = {}
            json_hms["political_group_id"] = parseInt(row_id)
            json_hms["Libelle"] = row.NAME
            json_hms["candidats_journaux"] = row.JOURNAUX.CANDIDAT.milliseconds === 0 ? "--" : row.JOURNAUX.CANDIDAT.hms
            json_hms["soutiens_journaux"] = row.JOURNAUX.SOUTIEN.milliseconds === 0 ? "--" : row.JOURNAUX.SOUTIEN.hms
            json_hms["duree_temps_journaux"] = row.JOURNAUX.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.JOURNAUX.TOTAL_EMISSION.hms
            json_hms["%_temps_journaux"] = row.JOURNAUX.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.JOURNAUX.TOTAL_EMISSION.percent
            json_hms["candidats_mag"] = row.MAGAZINES.CANDIDAT.milliseconds === 0 ? "--" : row.MAGAZINES.CANDIDAT.hms
            json_hms["soutiens_mag"] = row.MAGAZINES.SOUTIEN.milliseconds === 0 ? "--" : row.MAGAZINES.SOUTIEN.hms
            json_hms["duree_temps_mag"] = row.MAGAZINES.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.MAGAZINES.TOTAL_EMISSION.hms
            json_hms["%_temps_mag"] = row.MAGAZINES.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.MAGAZINES.TOTAL_EMISSION.percent
            json_hms["candidats_autres"] = row.AUTRES.CANDIDAT.milliseconds === 0 ? "--" : row.AUTRES.CANDIDAT.hms
            json_hms["soutiens_autres"] = row.AUTRES.SOUTIEN.milliseconds === 0 ? "--" : row.AUTRES.SOUTIEN.hms
            json_hms["duree_temps_autres"] = row.AUTRES.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.AUTRES.TOTAL_EMISSION.hms
            json_hms["%_temps_autres"] = row.AUTRES.TOTAL_EMISSION.milliseconds === 0 ? "--" : row.AUTRES.TOTAL_EMISSION.percent
            if (row.TOTAL_GROUPE !== undefined) {
              json_hms["duree_total"] = row.TOTAL_GROUPE.milliseconds === 0 ? "--" : row.TOTAL_GROUPE.hms
              json_hms["%_total"] = row.TOTAL_GROUPE.milliseconds === 0 ? "--" : row.TOTAL_GROUPE.percent
            }
            data_hms.push(json_hms)

            json_percent["Libelle"] = row.NAME
            json_percent["political_group_id"] = parseInt(row_id)
            json_percent["candidats_journaux"] = editData(row.JOURNAUX.CANDIDAT, row.JOURNAUX.CANDIDAT.percent)
            json_percent["soutiens_journaux"] = editData(row.JOURNAUX.SOUTIEN, row.JOURNAUX.SOUTIEN.percent)
            json_percent["duree_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.hms)
            json_percent["%_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.percent)
            json_percent["candidats_mag"] = editData(row.MAGAZINES.CANDIDAT, row.MAGAZINES.CANDIDAT.percent)
            json_percent["soutiens_mag"] = editData(row.MAGAZINES.SOUTIEN, row.MAGAZINES.SOUTIEN.percent)
            json_percent["duree_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.hms)
            json_percent["%_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.percent)
            json_percent["candidats_autres"] = editData(row.AUTRES.CANDIDAT, row.AUTRES.CANDIDAT.percent)
            json_percent["soutiens_autres"] = editData(row.AUTRES.SOUTIEN, row.AUTRES.SOUTIEN.percent)
            json_percent["duree_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.hms)
            json_percent["%_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.percent)
            if (row.TOTAL_GROUPE !== undefined) {
              json_percent["duree_total"] = editData(row.TOTAL_GROUPE, row.TOTAL_GROUPE.hms)
              json_percent["%_total"] = editData(row.TOTAL_GROUPE, row.TOTAL_GROUPE.percent)
            }
            data_percent.push(json_percent)
            return [data_hms, data_percent]
          })
        } else if (key.toUpperCase() === 'TOTAL') {
          let row: IRowData = res[key]
          let json_hms: any = {}
          json_hms["Libelle"] = 'Total'
          json_hms["candidats_journaux"] = editData(row.JOURNAUX.CANDIDAT, row.JOURNAUX.CANDIDAT.hms)
          json_hms["soutiens_journaux"] = editData(row.JOURNAUX.SOUTIEN, row.JOURNAUX.SOUTIEN.hms)
          json_hms["duree_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.hms)
          json_hms["%_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.percent)
          json_hms["candidats_mag"] = editData(row.MAGAZINES.CANDIDAT, row.MAGAZINES.CANDIDAT.hms)
          json_hms["soutiens_mag"] = editData(row.MAGAZINES.SOUTIEN, row.MAGAZINES.SOUTIEN.hms)
          json_hms["duree_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.hms)
          json_hms["%_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.percent)
          json_hms["candidats_autres"] = editData(row.AUTRES.CANDIDAT, row.AUTRES.CANDIDAT.hms)
          json_hms["soutiens_autres"] = editData(row.AUTRES.SOUTIEN, row.AUTRES.SOUTIEN.hms)
          json_hms["duree_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.hms)
          json_hms["%_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.percent)
          if (row.TOTAL !== undefined) {
            json_hms["duree_total"] = editData(row.TOTAL, row.TOTAL.hms)
            json_hms["%_total"] = editData(row.TOTAL, row.TOTAL.percent)
          }
          data_hms.push(json_hms)
          //percent
          let json_percent: any = {}
          json_percent["Libelle"] = 'Total'
          json_percent["candidats_journaux"] = editData(row.JOURNAUX.CANDIDAT, row.JOURNAUX.CANDIDAT.percent)
          json_percent["soutiens_journaux"] = editData(row.JOURNAUX.SOUTIEN, row.JOURNAUX.SOUTIEN.percent)
          json_percent["duree_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.hms)
          json_percent["%_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.percent)
          json_percent["candidats_mag"] = editData(row.MAGAZINES.CANDIDAT, row.MAGAZINES.CANDIDAT.percent)
          json_percent["soutiens_mag"] = editData(row.MAGAZINES.SOUTIEN, row.MAGAZINES.SOUTIEN.percent)
          json_percent["duree_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.hms)
          json_percent["%_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.percent)
          json_percent["candidats_autres"] = editData(row.AUTRES.CANDIDAT, row.AUTRES.CANDIDAT.percent)
          json_percent["soutiens_autres"] = editData(row.AUTRES.SOUTIEN, row.AUTRES.SOUTIEN.percent)
          json_percent["duree_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.hms)
          json_percent["%_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.percent)
          if (row.TOTAL !== undefined) {
            json_percent["duree_total"] = editData(row.TOTAL, row.TOTAL.hms)
            json_percent["%_total"] = editData(row.TOTAL, row.TOTAL.percent)
          }
          data_percent.push(json_percent)
        }
        return [data_hms, data_percent]
      })
      return {
        ...state,
        elections: action.payload,
        national_data_hms: data_hms,
        national_data_percent: data_percent,
        election_dashboard_loading: false
      }
    }
    case IElectionsActionTypes.GET_DASHBOARD_CIRCONSCRIPTION: {
      let newState = {
        ...state,
        dashboard_elections_filters: action.payload,
        study_type_id: action.payload.study_type_id,
        circonscription_virt_dashboard_loading: false,
        circonscription_dashboard_loading: true
      }
      if (state.tableType === ElectionType.CIRCONSCRIPTION_VIRTUELLE) {
        newState = {
          ...newState,
          circonscription_dashboard_loading: false,
          circonscription_virt_dashboard_loading: true
        }
      }
      return newState
    }
    case IElectionsActionTypes.GET_DASHBOARD_CIRCONSCRIPTION_SUCCESS: {
      let datas: any = []
      let res: IDashboardCircoData = action.payload
      let json_id: any = {}
      let name: string = ''
      Object.keys(res).map(key => {
        if (key === 'ROWS') {
          let rows: IROWS = res[key]
          Object.keys(rows).map(row_id => {
            let row: IRow = rows[row_id]
            name = row.NAME
            json_id = { "id": row_id, "name": name, "hms": [], "percent": [] }
            let row_data: any = row['DATA']

            let data_hms: any = []
            let data_percent: any = []
            Object.keys(row_data).map(data_id => {
              let datax: IRowData = row_data[data_id]
              let json_hms: any = { "Libelle": {} }
              let json_percent: any = { "Libelle": {} }

              json_percent["detail_etude_id"] = parseInt(row_id)
              json_hms["detail_etude_id"] = parseInt(row_id)
              json_percent["political_group_id"] = parseInt(data_id)
              json_hms["political_group_id"] = parseInt(data_id)
              json_hms["Libelle"]["candidat"] = datax.NAME
              json_hms["Libelle"]["formation"] = datax.REGIM
              json_hms["candidats_journaux"] = editData(datax.JOURNAUX.CANDIDAT, datax.JOURNAUX.CANDIDAT.hms)
              json_hms["soutiens_journaux"] = editData(datax.JOURNAUX.SOUTIEN, datax.JOURNAUX.SOUTIEN.hms)
              json_hms["duree_temps_journaux"] = editData(datax.JOURNAUX.TOTAL_EMISSION, datax.JOURNAUX.TOTAL_EMISSION.hms)
              json_hms["%_temps_journaux"] = editData(datax.JOURNAUX.TOTAL_EMISSION, datax.JOURNAUX.TOTAL_EMISSION.percent)
              json_hms["candidats_mag"] = editData(datax.MAGAZINES.CANDIDAT, datax.MAGAZINES.CANDIDAT.hms)
              json_hms["soutiens_mag"] = editData(datax.MAGAZINES.SOUTIEN, datax.MAGAZINES.SOUTIEN.hms)
              json_hms["duree_temps_mag"] = editData(datax.MAGAZINES.TOTAL_EMISSION, datax.MAGAZINES.TOTAL_EMISSION.hms)
              json_hms["%_temps_mag"] = editData(datax.MAGAZINES.TOTAL_EMISSION, datax.MAGAZINES.TOTAL_EMISSION.percent)
              json_hms["candidats_autres"] = editData(datax.AUTRES.CANDIDAT, datax.AUTRES.CANDIDAT.hms)
              json_hms["soutiens_autres"] = editData(datax.AUTRES.SOUTIEN, datax.AUTRES.SOUTIEN.hms)
              json_hms["duree_temps_autres"] = editData(datax.AUTRES.TOTAL_EMISSION, datax.AUTRES.TOTAL_EMISSION.hms)
              json_hms["%_temps_autres"] = editData(datax.AUTRES.TOTAL_EMISSION, datax.AUTRES.TOTAL_EMISSION.percent)
              if (datax.TOTAL_GROUPE !== undefined) {
                json_hms["duree_total"] = editData(datax.TOTAL_GROUPE, datax.TOTAL_GROUPE.hms)
                json_hms["%_total"] = editData(datax.TOTAL_GROUPE, datax.TOTAL_GROUPE.percent)
              }
              data_hms.push(json_hms)

              json_percent["Libelle"]["candidat"] = datax.NAME
              json_percent["Libelle"]["formation"] = datax.REGIM
              json_percent["candidats_journaux"] = editData(datax.JOURNAUX.CANDIDAT, datax.JOURNAUX.CANDIDAT.percent)
              json_percent["soutiens_journaux"] = editData(datax.JOURNAUX.SOUTIEN, datax.JOURNAUX.SOUTIEN.percent)
              json_percent["duree_temps_journaux"] = editData(datax.JOURNAUX.TOTAL_EMISSION, datax.JOURNAUX.TOTAL_EMISSION.hms)
              json_percent["%_temps_journaux"] = editData(datax.JOURNAUX.TOTAL_EMISSION, datax.JOURNAUX.TOTAL_EMISSION.percent)
              json_percent["candidats_mag"] = editData(datax.MAGAZINES.CANDIDAT, datax.MAGAZINES.CANDIDAT.percent)
              json_percent["soutiens_mag"] = editData(datax.MAGAZINES.SOUTIEN, datax.MAGAZINES.SOUTIEN.percent)
              json_percent["duree_temps_mag"] = editData(datax.MAGAZINES.TOTAL_EMISSION, datax.MAGAZINES.TOTAL_EMISSION.hms)
              json_percent["%_temps_mag"] = editData(datax.MAGAZINES.TOTAL_EMISSION, datax.MAGAZINES.TOTAL_EMISSION.percent)
              json_percent["candidats_autres"] = editData(datax.AUTRES.CANDIDAT, datax.AUTRES.CANDIDAT.percent)
              json_percent["soutiens_autres"] = editData(datax.AUTRES.SOUTIEN, datax.AUTRES.SOUTIEN.percent)
              json_percent["duree_temps_autres"] = editData(datax.AUTRES.TOTAL_EMISSION, datax.AUTRES.TOTAL_EMISSION.hms)
              json_percent["%_temps_autres"] = editData(datax.AUTRES.TOTAL_EMISSION, datax.AUTRES.TOTAL_EMISSION.percent)
              if (datax.TOTAL_GROUPE !== undefined) {
                json_percent["duree_total"] = editData(datax.TOTAL_GROUPE, datax.TOTAL_GROUPE.hms)
                json_percent["%_total"] = editData(datax.TOTAL_GROUPE, datax.TOTAL_GROUPE.percent)
              }
              data_percent.push(json_percent)

              return [data_hms, data_percent]
            })
            json_id["hms"] = data_hms
            json_id["percent"] = data_percent

            datas.push(json_id)
            return datas
          })
        } else if (key === 'TOTAL') {
          let rows: any = res[key]
          Object.keys(rows).map(row_id => {
            let row: IRowData = rows[row_id]
            json_id = datas.filter(x => x.id === row_id)[0]
            let json_hms: any = {}
            json_hms["Libelle"] = 'Totaux'
            json_hms["detail_etude_id"] = parseInt(row_id)
            json_hms["candidats_journaux"] = editData(row.JOURNAUX.CANDIDAT, row.JOURNAUX.CANDIDAT.hms)
            json_hms["soutiens_journaux"] = editData(row.JOURNAUX.SOUTIEN, row.JOURNAUX.SOUTIEN.hms)
            json_hms["duree_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.hms)
            json_hms["%_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.percent)
            json_hms["candidats_mag"] = editData(row.MAGAZINES.CANDIDAT, row.MAGAZINES.CANDIDAT.hms)
            json_hms["soutiens_mag"] = editData(row.MAGAZINES.SOUTIEN, row.MAGAZINES.SOUTIEN.hms)
            json_hms["duree_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.hms)
            json_hms["%_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.percent)
            json_hms["candidats_autres"] = editData(row.AUTRES.CANDIDAT, row.AUTRES.CANDIDAT.hms)
            json_hms["soutiens_autres"] = editData(row.AUTRES.SOUTIEN, row.AUTRES.SOUTIEN.hms)
            json_hms["duree_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.hms)
            json_hms["%_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.percent)
            if (row.TOTAL !== undefined) {
              json_hms["duree_total"] = editData(row.TOTAL, row.TOTAL.hms)
              json_hms["%_total"] = editData(row.TOTAL, row.TOTAL.percent)
            }
            json_id["hms"].push(json_hms)
            //percent
            let json_percent: any = {}
            json_percent["Libelle"] = 'Totaux'
            json_percent["detail_etude_id"] = parseInt(row_id)
            json_percent["candidats_journaux"] = editData(row.JOURNAUX.CANDIDAT, row.JOURNAUX.CANDIDAT.percent)
            json_percent["soutiens_journaux"] = editData(row.JOURNAUX.SOUTIEN, row.JOURNAUX.SOUTIEN.percent)
            json_percent["duree_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.hms)
            json_percent["%_temps_journaux"] = editData(row.JOURNAUX.TOTAL_EMISSION, row.JOURNAUX.TOTAL_EMISSION.percent)
            json_percent["candidats_mag"] = editData(row.MAGAZINES.CANDIDAT, row.MAGAZINES.CANDIDAT.percent)
            json_percent["soutiens_mag"] = editData(row.MAGAZINES.SOUTIEN, row.MAGAZINES.SOUTIEN.percent)
            json_percent["duree_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.hms)
            json_percent["%_temps_mag"] = editData(row.MAGAZINES.TOTAL_EMISSION, row.MAGAZINES.TOTAL_EMISSION.percent)
            json_percent["candidats_autres"] = editData(row.AUTRES.CANDIDAT, row.AUTRES.CANDIDAT.percent)
            json_percent["soutiens_autres"] = editData(row.AUTRES.SOUTIEN, row.AUTRES.SOUTIEN.percent)
            json_percent["duree_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.hms)
            json_percent["%_temps_autres"] = editData(row.AUTRES.TOTAL_EMISSION, row.AUTRES.TOTAL_EMISSION.percent)
            if (row.TOTAL !== undefined) {
              json_percent["duree_total"] = editData(row.TOTAL, row.TOTAL.hms)
              json_percent["%_total"] = editData(row.TOTAL, row.TOTAL.percent)
            }
            json_id["percent"].push(json_percent)
            return datas
          })
        }
        return datas
      })
      if (state.tableType === ElectionType.CIRCONSCRIPTION) {
        return {
          ...state,
          regional_data: datas,
          circonscription_dashboard_loading: false,
          circonscription_virt_dashboard_loading: false,
          circ_data: action.payload
        }
      } else if (state.tableType === ElectionType.CIRCONSCRIPTION_VIRTUELLE) {
        return {
          ...state,
          regional_virt_data: datas,
          circonscription_dashboard_loading: false,
          circonscription_virt_dashboard_loading: false,
          circ_virt_data: action.payload
        }
      } else return { ...state }
    }
    case IElectionsActionTypes.SAVE_CIRCO_FILTERS: {
      let filters: ICircoFilters = action.payload
      let newState = { ...state }
      newState = {
        ...state,
        circoFilters: action.payload,
      }
      if (state.dashboard_elections_filters !== null) {
        newState = {
          ...state,
          circoFilters: action.payload,
          dashboard_elections_filters: {
            ...state.dashboard_elections_filters,
            is_nat: filters.is_nat
          }
        }
      }
      return newState
    }
    case IElectionsActionTypes.GET_DASHBOARD_ELECTION_DETAIL: {
      return {
        ...state,
        dasboardDetailsFilters: action.payload,
        isLoadingDetail: true,
        dashboardElectionDetail: null
      }
    }
    case IElectionsActionTypes.GET_DASHBOARD_ELECTION_DETAIL_SUCCESS: {
      return {
        ...state,
        dashboardElectionDetail: action.payload,
        isLoadingDetail: false
      }
    }
    case IElectionsActionTypes.GET_XLS_DASHBOARD_ELECTION_DETAIL: {
      return { ...state }
    }
    case IElectionsActionTypes.GET_XLS_DASHBOARD_ELECTION_DETAIL_SUCCESS: {
      return {
        ...state,
        xls_dashboard_election: action.payload
      }
    }
    case IElectionsActionTypes.GET_XLS_DECLARATION_CSA: {
      return {
        ...state,
        xls_declaration_filters: action.payload
      }
    }
    case IElectionsActionTypes.GET_XLS_DECLARATION_CSA_SUCCESS: {
      return {
        ...state,
        xls_declaration_csa: action.payload
      }
    }
    case IElectionsActionTypes.GET_DECLARATION_CSA: {
      return {
        ...state,
        isDeclarationDetailLoading: true,
        decalarion_details: null,
        declarations_csa_filters: action.payload
      }
    }
    case IElectionsActionTypes.GET_DECLARATION_CSA_SUCCESS: {
      return {
        ...state,
        isDeclarationDetailLoading: false,
        decalarion_details: action.payload
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION: {
      return {
        ...state,
        timeAllocationsLoading: true,
        time_allocation_filters: action.payload
      }
    }
    case IElectionsActionTypes.GET_TIME_ALLLOCATION_SUCCESS: {
      let data_hms: any = []
      let data_percent: any = []
      let res: any = action.payload[0];
      Object.keys(res).map(rkey => {
        // fill datas
        if (rkey === 'datas') {
          let details_etude_id_data: any = res[rkey]
          Object.keys(details_etude_id_data).map(detail_etude_id_key => {
            let detail_etude_data: IDetailEtudeIdData = details_etude_id_data[detail_etude_id_key]
            let detail_etude_id = detail_etude_data.detail_etude_id

            let datas_by_political_group: { [data_id: number]: IDataTime } = detail_etude_data.datas;
            Object.keys(datas_by_political_group).map(pgid => {
              let existed_json_hms = data_hms.filter(x => x.political_group_id === parseInt(pgid))[0];
              let existed_json_percent = data_percent.filter(x => x.political_group_id === parseInt(pgid))[0];
              let json_hms: any = existed_json_hms || {};
              let json_percent: any = existed_json_percent || {};
              let political_group_data: IDataTime = datas_by_political_group[pgid];
              json_hms["political_group_id"] = parseInt(pgid);
              json_hms["Libelle"] = res.political_group_list[pgid].political_group_name;
              json_percent["political_group_id"] = parseInt(pgid);
              json_percent["Libelle"] = res.political_group_list[pgid].political_group_name;
              // CANDIDATS
              if (political_group_data.CANDIDAT) {
                json_hms[`candidats_${detail_etude_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.hms;
                json_percent[`candidats_${detail_etude_id}`] = political_group_data.CANDIDAT.milliseconds === 0 ? "--" : political_group_data.CANDIDAT.percent;
              } else {
                json_hms[`candidats_${detail_etude_id}`] = "--";
                json_percent[`candidats_${detail_etude_id}`] = "--";
              }
              // SOUTIENS
              if (political_group_data.SOUTIEN) {
                json_hms[`soutiens_${detail_etude_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.hms;
                json_percent[`soutiens_${detail_etude_id}`] = political_group_data.SOUTIEN.milliseconds === 0 ? "--" : political_group_data.SOUTIEN.percent;
              } else {
                json_hms[`soutiens_${detail_etude_id}`] = "--";
                json_percent[`soutiens_${detail_etude_id}`] = "--";
              }
              // TOTAL
              json_hms[`duree_${detail_etude_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.hms
              json_hms[`%_${detail_etude_id}`] = political_group_data.TOTAL.milliseconds === 0 ? "--" : political_group_data.TOTAL.percent
              json_percent[`duree_${detail_etude_id}`] = json_hms[`duree_${detail_etude_id}`];
              json_percent[`%_${detail_etude_id}`] = json_hms[`%_${detail_etude_id}`];

              if (!existed_json_hms) {
                data_hms.push(json_hms)
                data_percent.push(json_percent)
              }
              return [data_hms, data_percent]
            })
            return [data_hms, data_percent]
          })
        }
        // fill last column (total)
        if (rkey === 'totaux') {
          let totaux: any = res[rkey]
          let totaux_by_political_group_id = totaux['by_political_group_id']
          Object.keys(totaux_by_political_group_id).map(political_group_id => {
            let total_by_political_group_id = totaux_by_political_group_id[political_group_id];
            let json_hms = data_hms.filter(x => x['political_group_id'] === parseInt(political_group_id))[0] || {}
            let json_percent = data_percent.filter(x => x['political_group_id'] === parseInt(political_group_id))[0] || {}

            if (Object.keys(json_hms) !== undefined) {
              json_hms['duree_total'] = total_by_political_group_id.hms;
              json_hms['%_total'] = total_by_political_group_id.percent;
              json_percent['duree_total'] = json_hms['duree_total'];
              json_percent['%_total'] = json_hms['%_total'];
            }
            return [json_hms, json_percent]
          })
          // fill total global of last row
          let totaux_by_detail_etude_id = totaux['by_detail_etude_id']
          let json_hms_total = data_hms.filter(x => x['Libelle'] === "Total")[0] || { "Libelle": "Total" }
          let json_percent_total = data_percent.filter(x => x['Libelle'] === "Total")[0] || { "Libelle": "Total" }
          Object.keys(totaux_by_detail_etude_id).map(detail_etude_id => {
            let total = totaux_by_detail_etude_id[detail_etude_id];
            json_hms_total[`duree_${detail_etude_id}`] = total.milliseconds === 0 ? "--" : total.hms;
            json_hms_total[`%_${detail_etude_id}`] = action.payload[1]["show_total"] ? (total.milliseconds === 0 ? "--" : total.percent) : "100%";
            json_percent_total[`duree_${detail_etude_id}`] = json_hms_total[`duree_${detail_etude_id}`];
            json_percent_total[`%_${detail_etude_id}`] = json_hms_total[`%_${detail_etude_id}`];
            return [json_hms_total, json_percent_total]
          })

          let total_global = totaux['global'];
          json_hms_total['duree_total'] = total_global.hms;
          json_hms_total['%_total'] = total_global.percent;
          json_percent_total['duree_total'] = json_hms_total['duree_total'];
          json_percent_total['%_total'] = json_hms_total['%_total'];
        }
        // fill total last row
        if (rkey === 'datas') {
          let details_etude_id_data: any = res[rkey]
          let existed_json_hms = data_hms.filter(x => x['Libelle'] === "Total")[0];
          let existed_json_percent = data_percent.filter(x => x['Libelle'] === "Total")[0];
          let json_hms: any = existed_json_hms || { "Libelle": "Total" };
          let json_percent: any = existed_json_percent || { "Libelle": "Total" };
          Object.keys(details_etude_id_data).map(detail_etude_id_key => {
            let detail_etude_data: IDetailEtudeIdData = details_etude_id_data[detail_etude_id_key]
            let detail_etude_id = detail_etude_data.detail_etude_id

            if (detail_etude_data.TOTAL_CANDIDAT) {
              json_hms[`candidats_${detail_etude_id}`] = detail_etude_data.TOTAL_CANDIDAT.milliseconds === 0 ? "--" : detail_etude_data.TOTAL_CANDIDAT.hms
              json_percent[`candidats_${detail_etude_id}`] = detail_etude_data.TOTAL_CANDIDAT.milliseconds === 0 ? "--" : detail_etude_data.TOTAL_CANDIDAT.percent
            } else {
              json_hms[`candidats_${detail_etude_id}`] = "--";
              json_percent[`candidats_${detail_etude_id}`] = "--";
            }
            if (detail_etude_data.TOTAL_SOUTIEN) {
              json_hms[`soutiens_${detail_etude_id}`] = detail_etude_data.TOTAL_SOUTIEN.milliseconds === 0 ? "--" : detail_etude_data.TOTAL_SOUTIEN.hms
              json_percent[`soutiens_${detail_etude_id}`] = detail_etude_data.TOTAL_SOUTIEN.milliseconds === 0 ? "--" : detail_etude_data.TOTAL_SOUTIEN.percent
            } else {
              json_hms[`soutiens_${detail_etude_id}`] = "--";
              json_percent[`soutiens_${detail_etude_id}`] = "--";
            }

            return [json_hms, json_percent]
          })
          data_hms.push(json_hms)
          data_percent.push(json_percent)
        }




        return [data_hms, data_percent]
      })

      return {
        ...state,
        time_allocation_hms: data_hms,
        time_allocation_percent: data_percent,
        timeAllocationsLoading: false,
        timeAllocationResults: action.payload[0],
        tableType: ElectionType.NATIONAL,
        election_dashboard_loading: false
      }
    }
    default: {
      return state;
    }
  }
};

export { reducer as ElectionReducer };
